import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { HintboxOptions, ComponentRef } from '@inscomponents/core';
import { HintboxController } from '../wc-controllers/hintbox.controller';

@Directive({ selector: '[sklHintbox]' })
export class HintboxDirective {

    @Input('sklHintbox') public data!: Partial<HintboxOptions<ComponentRef>>;

    private isExpanded = false;
    private overlay!: HTMLInsHintboxPopupElement | undefined;

    public constructor(
        private readonly elmRef: ElementRef,
        protected hintboxController: HintboxController,
    ) { }

    private async showHintbox(): Promise<void> {
        const anchor = this.elmRef.nativeElement as HTMLElement;

        if (this.isExpanded || !anchor) {
            return;
        }

        this.isExpanded = true;

        const overlay = this.overlay = await this.createHintbox({
            anchor,
            ...this.data,
        });

        overlay.onDidDismiss().then(() => {
            this.overlay = undefined;
            this.isExpanded = false;
        });

        anchor ? await overlay.present() : this.closeHintbox();
    }

    private async closeHintbox(): Promise<boolean> {
        return !this.overlay ? Promise.resolve(false) : this.overlay.dismiss();
    }

    private createHintbox(config?: HintboxOptions): Promise<HTMLInsHintboxPopupElement> {
        return this.hintboxController.create(config ?? {});
    }

    @HostListener('click')
    protected handleTooltipShow(): void {
        this.showHintbox();
    }
}